import {Component, Input, OnInit} from '@angular/core';
import {ImageBlock} from '../../../common/services/page';
import {PageHelper} from '../../../common/services';
import {ImagePreviewComponent} from '../../../settings/images/image-preview/image-preview.component';
import {Image} from '../../../common/services';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'p8-bdc-image-block',
  templateUrl: './image-block.component.html',
  styleUrls: ['./image-block.component.scss']
})
export class ImageBlockComponent implements OnInit {
  @Input() block: ImageBlock;

  constructor(private pageHelper: PageHelper,
              private dialog: MatDialog) { }

  ngOnInit() {
  }

  /***
   * Calcul de l'URL de l'image
   * @param {ImageBlock} block
   * @return {string | File}
   */
  calculateUrl(block: ImageBlock) {
    return this.pageHelper.calculeUrlImage(block);
  }

  /**
   * Visualisation dans une popin de l'image
   * @param {Image} image
   */
  visualiser() {
    const modal = this.dialog.open(ImagePreviewComponent, {data: {file: this.block.value.file, id: this.block.value.imageId}});
    modal.updatePosition({top: '50px'});
  }
}
